import {
	addDays,
	getDuration,
	getTzEndOfDay,
	getTzStartOfDay,
	getTzTodayDate,
	parseIsoDateTime,
} from '@ninja/utilities';

const SECONDS_IN_DAY = 86400;

const calculateAgeInDays = (birthDateValue: string) => {
	const endDate = getTzEndOfDay(addDays(getTzTodayDate(), 1));
	const startDate = getTzStartOfDay(parseIsoDateTime(birthDateValue) as Date);
	const duration = getDuration(endDate, startDate);

	return Math.floor(duration.totalSeconds / SECONDS_IN_DAY);
};

export default calculateAgeInDays;
